import React from 'react';
import PropTypes from 'prop-types';
import styles from './Navbar.module.scss';
import classNames from 'classnames';

const NavbarContainer = ({ children, position }) => (
  <div
    className={classNames(`navbar-${position}`, styles.navContainer, styles[`navContainer-${position}`])}
    style={{ alignItems: 'center' }}
  >
    {children}
  </div>
);

NavbarContainer.propTypes = {
  children: PropTypes.node,
  position: PropTypes.oneOf(['start', 'end']),
};

NavbarContainer.defaultProps = {
  position: 'start',
};

export default NavbarContainer;
